import { api } from "./apiSetting";


async function login(username, password) {
    const response = await api.post('/j/login/', {username: username, password: password}, {headers: {'Content-Type': 'multipart/form-data'}})
    return response
}

async function getOffice() {
    const response = await api('/is_office/')
    return response
}

async function loginIntern() {
    const response = await api.post('/is_office/')
    return response
}

export { login, getOffice, loginIntern }
